import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { BrandWrapper } from 'src/modules/onboarding/components/BrandWrapper';
import image from 'src/public/img/marginalia-done.svg';
import { InternalLinkButton } from 'src/shared/components/InternalLinkButton';
import { BodyTextMedium, HeadingText50 } from '@modernhealth/vital-components';

const Wrapper = styled.div({
    maxWidth: 492,
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: 1,
    paddingBottom: 100,
});

const Image = styled.img({
    width: 200,
    alignSelf: 'center',
});

export const PreSessionAssessmentsScorePage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <BrandWrapper>
            <Wrapper>
                <Image src={image} />
                <HeadingText50 centered css={{ marginBottom: 25 }}>
                    {t('assessments:pre_session_assessment_score.title')}
                </HeadingText50>
                <BodyTextMedium centered css={{ marginBottom: 50 }}>
                    {t('assessments:pre_session_assessment_score.description')}
                </BodyTextMedium>
                <InternalLinkButton size="large" to="/" variant="primary">
                    {t('common.continue')}
                </InternalLinkButton>
            </Wrapper>
        </BrandWrapper>
    );
};
